import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import toast from "react-hot-toast";
import { server } from "../server";

const ContactsPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate if all fields are filled
    if (!formData.name || !formData.email || !formData.message) {
      toast.error("Please fill in all fields before submitting.");
      return;
    }

    const toasId = toast.loading("Sending ... ");

    try {
      const response = await fetch(`${server}/send-email`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: "dadyjohn2004@gmail.com",
          subject: `Message from ${formData.name}`,
          message: `
            <html>
              <body style="font-family: Arial, sans-serif; background-color: #f4f4f4; padding: 20px; color: #333;">
                <div style="background-color: #fff; padding: 20px; border-radius: 8px; border: 1px solid #ccc;">
                  <h2 style="text-align: center; color: #e59400;">Greatings From Website</h2>
                  <h2 style="text-align: center; color: #e59400;">New Contact Form Message</h2>
                  <p><strong>Name:</strong> ${formData.name}</p>
                  <p><strong>Email:</strong> ${formData.email}</p>
                  <p><strong>Message:</strong></p>
                  <p style="background-color: #f9f9f9; padding: 10px; border-radius: 5px; font-style: italic;">${formData.message}</p>
                  <div style="text-align: center; margin-top: 20px;">
                    <p style="font-size: 14px; color: #888;">Thank you for your message! We will get back to you shortly.</p>
                  </div>
                </div>
              </body>
            </html>
          `,
        }),
      });

      if (response.ok) {
        toast.dismiss(toasId);
        toast.success(
          "Thank you for reaching out! We will get back to you shortly.",
          { duration: 10000 }
        );
        setFormData({
          name: "",
          email: "",
          message: "",
        });
      } else {
        toast.dismiss(toasId);
        toast.error(
          "Sorry, there was an issue sending your message. Please try again."
        );
      }
    } catch (error) {
      toast.dismiss(toasId);
      console.error("Error sending email:", error);
      toast.error(
        "Sorry, there was an issue sending your message. Please try again."
      );
    }
  };

  return (
    <>
      <Header />
      <div
        style={{
          margin: "70px auto",
          maxWidth: "1200px",
          padding: "50px 30px",
        }}
        className="section"
      >
        <section className="contacts-container">
          <form
            onSubmit={handleSubmit}
            style={{
              padding: "20px",
              border: "1px solid #ddd",
              borderRadius: "8px",
              marginBottom: "20px",
            }}
            className="contacts-card"
          >
            <h2
              style={{
                fontSize: "24px",
                marginBottom: "20px",
              }}
            >
              Send us a Message
            </h2>

            <div style={{ marginBottom: "15px" }}>
              <label
                htmlFor="name"
                style={{
                  display: "block",
                  fontSize: "14px",
                  color: "#666",
                  marginBottom: "5px",
                }}
              >
                Your Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                style={{
                  width: "100%",
                  padding: "10px",
                  fontSize: "16px",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                }}
              />
            </div>

            <div style={{ marginBottom: "15px" }}>
              <label
                htmlFor="email"
                style={{
                  display: "block",
                  fontSize: "14px",
                  color: "#666",
                  marginBottom: "5px",
                }}
              >
                Your Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                style={{
                  width: "100%",
                  padding: "10px",
                  fontSize: "16px",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                }}
              />
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label
                htmlFor="message"
                style={{
                  display: "block",
                  fontSize: "14px",
                  color: "#666",
                  marginBottom: "5px",
                }}
              >
                Your Message
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                style={{
                  width: "100%",
                  padding: "10px",
                  fontSize: "16px",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  minHeight: "150px",
                }}
              />
            </div>

            <button
              type="submit"
              style={{
                backgroundColor: "#e59400",
                color: "#fff",
                padding: "12px 25px",
                fontSize: "16px",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                width: "100%",
              }}
            >
              Send Message
            </button>
          </form>

          <div
            style={{
              padding: "20px",
              border: "1px solid #ddd",
              borderRadius: "8px",
              backgroundColor: "#f9f9f9",
              marginBottom: "20px",
            }}
            className="contacts-card"
          >
            <h2
              style={{
                fontSize: "24px",
                marginBottom: "20px",
              }}
            >
              Contact Information
            </h2>

            <div
              style={{
                backgroundColor: "#fff",
                padding: "15px",
                marginBottom: "15px",
                borderRadius: "8px",
              }}
            >
              <p
                style={{
                  fontSize: "16px",
                  marginBottom: "10px",
                }}
              >
                <strong>Email:</strong>{" "}
                <a
                  href="mailto:dadyjohn2004@gmail.com​"
                  style={{ color: "#007BFF" }}
                >
                  dadyjohn2004@gmail.com
                </a>
              </p>

              <p
                style={{
                  fontSize: "16px",
                  marginBottom: "10px",
                }}
              >
                <strong>Phone:</strong>{" "}
                <a href="tel:+254791871179" style={{ color: "#007BFF" }}>
                  +254 791 871 179
                </a>
              </p>

              <p
                style={{
                  fontSize: "16px",
                  marginBottom: "10px",
                }}
              >
                <strong>Address:</strong> Kisumu Airport, Nairobi, Kenya
              </p>
            </div>

            <div
              style={{
                backgroundColor: "#fff",
                padding: "15px",
                borderRadius: "8px",
              }}
            >
              <h3
                style={{
                  fontSize: "18px",
                  marginBottom: "10px",
                }}
              >
                Follow Us
              </h3>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  fontSize: "20px",
                }}
              >
                <a href="https://twitter.com" style={{ color: "#007BFF" }}>
                  <ion-icon name="logo-twitter"></ion-icon>
                </a>
                <a href="https://facebook.com" style={{ color: "#007BFF" }}>
                  <ion-icon name="logo-facebook"></ion-icon>
                </a>
                <a href="https://instagram.com" style={{ color: "#007BFF" }}>
                  <ion-icon name="logo-instagram"></ion-icon>
                </a>
                <a href="https://youtube.com" style={{ color: "#007BFF" }}>
                  <ion-icon name="logo-youtube"></ion-icon>
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Map Section */}
        <section>
          <h2
            style={{
              textAlign: "center",
              marginBottom: "20px",
            }}
          >
            Our Location
          </h2>
          <div
            style={{
              position: "relative",
              height: "400px",
              width: "100%",
              borderRadius: "5px",
            }}
          >
            <iframe
              title="Google Map"
              width="100%"
              height="100%"
              frameBorder="0"
              style={{ border: "0", borderRadius: "7px" }}
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3989.814241239369!2d34.726016674723375!3d-0.08193009991726012!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182aa5ac750c293d%3A0x229e6bdbae2184b6!2sKisumu%20International%20Airport!5e0!3m2!1sen!2ske!4v1732351305417!5m2!1sen!2ske"
              allowFullScreen=""
              aria-hidden="false"
              tabIndex="0"
            />
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default ContactsPage;
